import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { QuestionAnswer } from '../models/question';

@Injectable({
  providedIn: 'root'
})
export class QuestionService {

  constructor(private httpClient:HttpClient) {
  }

  public getQuestions(jobId:number){
    return this.httpClient.get<QuestionAnswer>(environment.API_BASE+"/items/questions?filter[job_id][eq]="+jobId);
  }
}
